export class Cities {
    static moduleName = 'cities';
    static moduleEntityName = 'citiesEntity';
    static listTitle = 'Справочник городов';
    static createTitle = 'Добавление нового города';
    static apiPrefix = 'cities';
}
